if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');

      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      /*
        Check if the product has personalised add ons 
        [data-personalise-option] is for shirt forms
      */
      if (this.form.querySelector('#no-personalisation') && !this.form.querySelector('#no-personalisation:checked') ||
          this.form.querySelector('[data-personalise-option]') && this.form.querySelector('[data-personalise-option]:checked')
      ){
        const selectedVariant = document.querySelector('.product-sku__value').innerHTML;
        const personalisedVariant = `input[type="hidden"][data-sku*="${selectedVariant}-PERS"]`;

        // Create a unique cart identifier for personalised products
        if (!document.querySelector('input[name="properties[_cartId]"')) {
          const uniqueCartID = document.createElement('input');
          uniqueCartID.hidden = true;
          uniqueCartID.setAttribute('name', 'properties[_cartId]');
          this.form.appendChild(uniqueCartID);
        } else {
          document.querySelector('input[name="properties[_cartId]"').disabled = false;
        }
        
        document.querySelector('input[name="properties[_cartId]"').setAttribute('value', Date.now());

        if (this.form.querySelector(personalisedVariant)) {
          this.form.querySelector('[name="id"]').value = this.form.querySelector(personalisedVariant).dataset.id;
        }
      } else if (!this.form.classList.contains('quick-add-form')) {
        // Disable the optional DC logo for discount checkbox
        const optionalLogoOptions = this.form.querySelectorAll('[name="properties[Darts_Corner_Logo]"]');
        if (optionalLogoOptions.length > 0) {
          optionalLogoOptions.forEach(elem => {
            elem.disabled = true;
          });
        }
        // Reset the variant SKU if a non-personalised product is added
        if (document.querySelector('.product-sku__value')) {
          const selectedVariant = document.querySelector('.product-sku__value').innerHTML;
          if (this.form.querySelector(`input[type="hidden"][data-sku*="${selectedVariant}"]`)) {
            const selectedSKU = `input[type="hidden"][data-sku*="${selectedVariant}"]`;
            this.form.querySelector('[name="id"]').value = this.form.querySelector(selectedSKU).dataset.id;
          }
        }
        // Disable unique Cart ID for non-personalised products
        if (document.querySelector('input[name="properties[_cartId]"')) {
          document.querySelector('input[name="properties[_cartId]"').disabled = true;
        }
      }

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        let newFormData = {
          items: []
        };

        const quantityInputValue = document.querySelector('input[name="quantity"]').value;

        if (document.querySelector('input[name="1PERSLASER"]:checked') && document.querySelector('input[name="1PERSLASER"]:checked').value !== "") {
          /*

          [Personalisation] 1PERSLASER checkbox is not set to 'None'
      
          */
          newFormData.items.push(
            {
              id: '43868015788214',
              quantity: quantityInputValue,
              properties:{
                forProduct: data.sku,
                _cartId: document.querySelector('[name="properties[_cartId]"]').value
              }
            }
          )
        } else if (document.querySelector('input[name="properties[Laser Barrels]"]:checked') && document.querySelector('input[name="properties[Laser Barrels]"]:checked').value !== "") {
          /*

          [properties[Laser Barrels] checkbox is not set to 'None'
      
          */
          newFormData.items.push(
            {
              id: '43868015788214',
              quantity: quantityInputValue,
              properties:{
                forProduct: data.sku,
                _cartId: document.querySelector('[name="properties[_cartId]"]').value
              }
            }
          )
        } else if (document.querySelector('input[name="properties[Moulded Flight]"]:checked') && document.querySelector('input[name="properties[Moulded Flight]"]:checked').value === "Personalised") {
          /*

          [Moulded Flight] checkbox is set to 'All'

          */
          newFormData.items.push(
            {
              id: '43868831580342',
              quantity: quantityInputValue,
              properties:{
                forProduct: data.sku,
                _cartId: document.querySelector('[name="properties[_cartId]"]').value
              }
            }
          )
        } else if (document.querySelector('input[name="properties[Shafts_Laser_Engraved]"]:checked') && document.querySelector('input[name="properties[Shafts_Laser_Engraved]"]:checked').value === "One Side Only") {
          /*

          [Shafts_Laser_Engraved] checkbox is set to 'One Side Only'

          */
          newFormData.items.push(
            {
              id: '43868015657142',
              quantity: quantityInputValue,
              properties:{
                forProduct: data.sku,
                _cartId: document.querySelector('[name="properties[_cartId]"]').value
              }
            }
          )
        } else if (document.querySelector('input[name="properties[Points_Laser_Engraved_enhanced]"]:checked') && document.querySelector('input[name="properties[Points_Laser_Engraved_enhanced]"]:checked').value === "One Side Only") {
          /*

          [Points_Laser_Engraved_enhanced] checkbox is set to 'One Side Only'

          */
          newFormData.items.push(
            {
              id: '43868098887862',
              quantity: quantityInputValue,
              properties:{
                forProduct: data.sku,
                _cartId: document.querySelector('[name="properties[_cartId]"]').value
              }
            }
          )
        } else if (document.querySelector('input[name="properties[Points_Laser_Engraved_enhanced]"]:checked') && document.querySelector('input[name="properties[Points_Laser_Engraved_enhanced]"]:checked').value === "Two Sides") {
          /*

           [Points_Laser_Engraved_enhanced] checkbox is set to 'Two Sides'

          */
          newFormData.items.push(
            {
              id: '43868098920630',
              quantity: quantityInputValue,
              properties:{
                forProduct: data.sku,
                _cartId: document.querySelector('[name="properties[_cartId]"]').value
              }
            }
          )
        } else if (document.querySelector('input[name="properties[Shafts_Laser_Engraved]"]:checked') && document.querySelector('input[name="properties[Shafts_Laser_Engraved]"]:checked').value === "Two Sides") {
          /*

          [Shafts_Laser_Engraved] checkbox is set to 'Two Sides'

          */
          newFormData.items.push(
            {
              id: '43868015689910',
              quantity: quantityInputValue,
              properties:{
                forProduct: data.sku,
                _cartId: document.querySelector('[name="properties[_cartId]"]').value
              }
            }
          )
        } else if (document.querySelector('input[name="properties[Printing_Area]"]:checked') && document.querySelector('input[name="properties[Printing_Area]"]:checked').value !== "") {
          /*
          
          [Printing_Area] checkbox is set to 'Simple_Print_Top_Area_Only' or 'Simple_Print_Bottom_Area_Only' or 'Simple_Print_Top_and_Bottom_Areas'
        
          */
          newFormData.items.push(
            {
              id: '43868016083126',
              quantity: quantityInputValue,
              properties:{
                forProduct: data.sku,
                _cartId: document.querySelector('[name="properties[_cartId]"]').value
              }
            }
          )
        } else if (document.querySelector('input[name="properties[Personalize_Printing_Area]"]:checked') && document.querySelector('input[name="properties[Personalize_Printing_Area]"]:checked').value !== "") {
          /*

          [Personalize_Printing_Area] checkbox is set to 'Print Top Area Only' or 'Print Bottom Area Only' or 'Print Top and Bottom Areas'

          */
          newFormData.items.push(
            {
              id: '43868016115894',
              quantity: quantityInputValue,
              properties:{
                forProduct: data.sku,
                _cartId: document.querySelector('[name="properties[_cartId]"]').value
              }
            }
          )
        } else if (document.querySelector('input[name="properties[Case_Printing_Area]"]:checked') && document.querySelector('input[name="properties[Case_Printing_Area]"]:checked').value === "Print Top Area Only" || document.querySelector('input[name="properties[Case_Printing_Area]"]:checked') && document.querySelector('input[name="properties[Case_Printing_Area]"]:checked').value === "Print Bottom Area Only") {
          /*

          [Case_Printing_Area] checkbox is set to 'Print Top Area Only' or 'Print Bottom Area Only'

          */
          newFormData.items.push(
            {
              id: '43868016017590',
              quantity: quantityInputValue,
              properties:{
                forProduct: data.sku,
                _cartId: document.querySelector('[name="properties[_cartId]"]').value
              }
            }
          )
        } else if (document.querySelector('input[name="properties[Case_Printing_Area]"]:checked') && document.querySelector('input[name="properties[Case_Printing_Area]"]:checked').value === "Print Top and Bottom Areas") {
          /*

           [Case_Printing_Area] checkbox is set to 'Print Top and Bottom Areas'

          */
          newFormData.items.push(
            {
              id: '43868016050358',
              quantity: quantityInputValue,
              properties:{
                forProduct: data.sku,
                _cartId: document.querySelector('[name="properties[_cartId]"]').value
              }
            }
          )
        }

        // Check if the product has personalised add ons
        if (document.querySelector('[data-personalise-option]') && document.querySelector('[data-personalise-option]:checked')) {
          const optionalDartsCornerLogo = document.querySelector('input[name="properties[Darts_Corner_Logo]"]:checked').value.toLowerCase();
          /*
            List of custom addons for shirts and their corresponding add on variant id's
            from the product admin
          */
          const addOns = [
            {
              'name': 'back-print',
              'id': '43868015755446'
            },
            {
              'name': 'collar',
              'id': '43868018671798'
            },
            {
              'name': 'left-pocket',
              'id': '43868018606262'
            },
            {
              'name': 'right-pocket',
              'id': '43868018639030'
            },
            {
              'name': 'left-arm',
              'id': '43868015853750'
            },
            {
              'name': 'right-arm',
              'id': '43868015886518'
            }
          ];
          
          /*
            Check which personalised add-ons are checked
          */
  
          addOns.forEach(attr => {
            if (this.form.querySelector(`[name="${attr.name}"]`) && this.form.querySelector(`[name="${attr.name}"]:checked`)) {
              newFormData.items.push(
                {
                  id: attr.id,
                  quantity: quantityInputValue,
                  properties:{
                    forProduct: data.sku,
                    additionDiscount: optionalDartsCornerLogo == "yes" ? "true" : "false",
                    _cartId: document.querySelector('[name="properties[_cartId]"]').value
                  }
                }
              )
            }
          });
        }

        if (newFormData.items.length > 0) {
          const newResponse = await postAdditionalData(newFormData)
        }
        
        /*
            Post personalised product options
        */
        async function postAdditionalData(formData) {
          const productPost = fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });

          return productPost;
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id && !item.sku.includes('PERS')
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));

          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: window._currencysignCustom,
              value: Number(data.price / 100),
              items: [{
                item_name: data.product_title,
                item_id: data.sku,
                price:  Number(data.price / 100),
                item_brand: data.vendor,
                item_category: data.product_type,
                item_variant: data.variant_title,
                in_stock: "yes",
                on_offer: data.total_discount != 0 ? "yes":"no",
                index: 0,
                quantity: data.quantity
              }]
            }
          });
        }
      } catch (error) {
        // console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);

        // Re-enable any DC logo options if they had been disabled
        const optionalLogoOptions = this.form.querySelectorAll('[name="properties[Darts_Corner_Logo]"]:disabled')
        if (optionalLogoOptions.length > 0) {
          optionalLogoOptions.forEach(elem => {
            elem.disabled = false;
          });
        }
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}

